module.exports = __webpack_public_path__ + "static/oldcouple-b4cc0a6c47aca5cecacebf7c78468299.jpg";